// modules
import api from './api'
import config from './config'
import logger from './logger'
import logos from './logos'
import objects from './objects'
import router from './router'
import store from './store'
import utils from './utils'

const countries = [
  'ad', 'ae', 'af', 'ag', 'ai', 'al', 'am', 'ao', 'aq', 'ar', 'as', 'at', 'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bl', 'bm', 'bn', 'bo', 'bq', 'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca', 'cc', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr', 'cu', 'cv', 'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'ee', 'eg', 'eh', 'er', 'es', 'et', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gs', 'gt', 'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'im', 'in', 'io', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kp', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mf', 'mg', 'mh', 'mk', 'ml', 'mm', 'mn', 'mo', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nc', 'ne', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz', 'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pn', 'pr', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'sh', 'si', 'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'sv', 'sx', 'sy', 'sz', 'tc', 'td', 'tf', 'tg', 'th', 'tj', 'tk', 'tl', 'tm', 'tn', 'to', 'tr', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'um', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vi', 'vn', 'vu', 'wf', 'ws', 'ye', 'yt', 'za', 'zm', 'zw', 'es-ca', 'eu', 'gb-eng', 'gb-nir', 'gb-sct', 'gb-wls', 'un', 'xk'
]

const goals = [
  'USER_SIGNUP_OPEN',
  'USER_SIGNUP_GITHUB',
  'USER_SIGNUP_BITBUCKET',
  'USER_SIGNUP_GOOGLE',
  'USER_SIGNUP_FACEBOOK',
  'USER_SIGNUP_TRY',
  'USER_SIGNUP_SUCCESS',
  'USER_SIGNUP_FAIL',

  'USER_SIGNIN_OPEN',
  'USER_SIGNIN_EMAIL',
  'USER_SIGNIN_GITHUB',
  'USER_SIGNIN_BITBUCKET',
  'USER_SIGNIN_GOOGLE',
  'USER_SIGNIN_FACEBOOK',
  'USER_SIGNIN_SUCCESS',
  'USER_SIGNIN_FAIL',
  'USER_RESET_OPEN',
  'USER_RESET_REQUEST',
  'USER_RESET_NEWPASS',
  'USER_RESET_SUCCESS',
  'USER_RESET_FAIL',
  'USER_JOIN_TRY',
  'USER_JOIN_SUCCESS',
  'USER_JOIN_FAIL',
  // ---------------------------------------------------------------------------
  'MENU_CREATE_HOST',
  'MENU_CREATE_KEY',
  'MENU_CREATE_PROJECT',
  'MENU_CREATE_PROVIDER',
  'MENU_CREATE_SERVICE',
  'MENU_CREATE_STACK',
  'MENU_MANAGE_ACCOUNTS',
  'MENU_MANAGE_MEMBERS',
  'MENU_MANAGE_ROLES',
  'MENU_MANAGE_KEYS',
  'MENU_MANAGE_PROVIDERS',
  'MENU_STACKHUB',
  'MENU_DOCS',
  'MENU_HELP_FAQ',
  'MENU_HELP_TICKET',
  'MENU_HELP_URGENT',
  'MENU_HELP_BASIC',
  'MENU_HELP_PREMIUM',
  'MENU_SOCIAL_DISCORD',
  'MENU_SOCIAL_FACEBOOK',
  'MENU_SOCIAL_TWITTER',
  'MENU_SOCIAL_GITHUB',
  'MENU_SOCIAL_ROADMAP',
  'MENU_USER_SELECT_ACCOUNT',
  'MENU_USER_ACCOUNTS_SETTINGS',
  'MENU_USER_KEYS_SETTINGS',
  'MENU_USER_PROVIDERS_SETTINGS',
  'MENU_USER_GENERAL_SETTINGS',
  'MENU_USER_PLANS_SETTINGS',
  'MENU_USER_PAYMENTS_SETTINGS',
  'MENU_USER_SECURITY_SETTINGS',
  'MENU_USER_LOGOUT',
  // ---------------------------------------------------------------------------
  'ACCOUNT_ACCOUNTS_ADD',
  'ACCOUNT_ACCOUNTS_EDIT',
  'ACCOUNT_ACCOUNTS_LOGIN',
  'ACCOUNT_MEMBERS_ADD',
  'ACCOUNT_MEMBERS_EDIT',
  'ACCOUNT_ROLES_ADD',
  'ACCOUNT_ROLES_EDIT',
  // ---------------------------------------------------------------------------
  'SETTINGS_PLANS_START_TRIAL',
  'SETTINGS_PLANS_SUBSCRIBE',
  'SETTINGS_PLANS_SUBSCRIBE_STARTER',
  'SETTINGS_PLANS_SUBSCRIBE_STARTERANNUAL',
  'SETTINGS_PLANS_SUBSCRIBE_PERSONAL',
  'SETTINGS_PLANS_SUBSCRIBE_PERSONALANNUAL',
  'SETTINGS_PLANS_SUBSCRIBE_TEAM',
  'SETTINGS_PLANS_SUBSCRIBE_TEAMANNUAL',
  'SETTINGS_PLANS_SUBSCRIBE_LINK',
  'SETTINGS_PLANS_CHANGE_FREE',
  'SETTINGS_PLANS_CHANGE_STARTER',
  'SETTINGS_PLANS_CHANGE_STARTERANNUAL',
  'SETTINGS_PLANS_CHANGE_PERSONAL',
  'SETTINGS_PLANS_CHANGE_PERSONALANNUAL',
  'SETTINGS_PLANS_CHANGE_TEAM',
  'SETTINGS_PLANS_CHANGE_TEAMANNUAL',
  'SETTINGS_PLANS_UPDATE_PAYMENT',
  'SETTINGS_PLANS_UPDATE_PAYMENT_LINK',
  'SETTINGS_PLANS_CANCEL_RENEWAL',
  'SETTINGS_PAYMENTS_OPEN_RECEIPT',
  'SETTINGS_PROVIDERS_ADD',
  'SETTINGS_PROVIDERS_DELETE_TRY',
  'SETTINGS_PROVIDERS_DELETE_SUCCESS',
  'SETTINGS_PROVIDERS_DELETE_FAIL',
  'SETTINGS_KEYS_ADD',
  'SETTINGS_KEYS_DELETE_TRY',
  'SETTINGS_KEYS_DELETE_SUCCESS',
  'SETTINGS_KEYS_DELETE_FAIL',
  'SETTINGS_SECURITY_NEWPASSWORD_GENERATE',
  'SETTINGS_SECURITY_NEWPASSWORD_COPY',
  'SETTINGS_SECURITY_NEWPASSWORD_TRY',
  'SETTINGS_SECURITY_NEWPASSWORD_SUCCESS',
  'SETTINGS_SECURITY_NEWPASSWORD_FAIL',
  // ---------------------------------------------------------------------------
  'PROJECT_CARDS_CREATE',
  'PROJECT_CARDS_IMPORT',
  'PROJECT_CARD_ACCESS',
  'SERVICE_CARDS_CREATE',
  'SERVICE_CARDS_IMPORT',
  'SERVICE_CARD_ACCESS',
  'SERVICE_CARD_CONTAINER_LOGS',
  'SERVICE_CARD_CONTAINER_TERMINAL',
  'SERVICE_CARD_DESTROY',
  'SERVICE_CARD_DESTROY_FAIL',
  'SERVICE_CARD_DESTROY_SUCCESS',
  'SERVICE_CARD_DESTROY_TRY',
  'SERVICE_CARD_EDIT',
  'SERVICE_CARD_LOGS',
  'SERVICE_CARD_RESTART',
  'SERVICE_CARD_START',
  'SERVICE_CARD_STOP',
  'SERVICE_CARD_UPDATE',
  'HOST_CARDS_CREATE',
  'HOST_CARDS_CONNECT',
  'HOST_CARDS_DEMO',
  'HOST_CARD_ACCESS',
  'HOST_CARD_COPY_IP',
  'HOST_CARD_EDIT',
  'HOST_CARD_LOGS',
  'HOST_CARD_METRICS',
  'HOST_CARD_RESTART',
  'HOST_CARD_START',
  'HOST_CARD_STOP',
  'HOST_CARD_TERMINAL',
  'HOST_CARD_UPDATE_UTILS',
  'HOST_CARD_DESTROY_TRY',
  'HOST_CARD_DESTROY_SUCCESS',
  'HOST_CARD_DESTROY_FAIL',
  'CONTAINERS_CARDS_SCALE_SERVICE',
  'CONTAINERS_CARDS_BALANCE_SERVICE',
  'CONTAINERS_CARDS_EXECUTE_SERVICE',
  'CONTAINERS_CARDS_OPEN_LOGPROVIDER',
  'CONTAINER_CARD_TERMINAL',
  'CONTAINER_CARD_METRICS',
  'CONTAINER_CARD_LOGS',
  'CONTAINER_CARD_MOVE',
  'CONTAINER_CARD_EXECUTE',
  'CONTAINER_CARD_START',
  'CONTAINER_CARD_STOP',
  'CONTAINER_CARD_RESTART',
  'CONTAINER_CARD_DESTROY',
  'CONTAINER_CARD_DESTROY_TRY',
  'CONTAINER_CARD_DESTROY_SUCCESS',
  'CONTAINER_CARD_DESTROY_FAIL',
  // ---------------------------------------------------------------------------
  'PROJECT_PAGE_RENAME',
  'PROJECT_PAGE_DESTROY',
  'PROJECT_PAGE_DESTROY_TRY',
  'PROJECT_PAGE_DESTROY_SUCCESS',
  'PROJECT_PAGE_DESTROY_FAIL',
  'PROJECT_PAGE_EMPTY',
  'PROJECT_PAGE_EMPTY_FORCE',
  'SERVICE_PAGE_WARNING_RECREATE',
  'SERVICE_PAGE_PROJECT_OPEN',
  'SERVICE_PAGE_PROJECT_MOVE',
  'SERVICE_PAGE_IMAGE_OPEN',
  'SERVICE_PAGE_IMAGE_UPDATE',
  'SERVICE_PAGE_START',
  'SERVICE_PAGE_RESTART',
  'SERVICE_PAGE_STOP',
  'SERVICE_PAGE_RECREATE',
  'SERVICE_PAGE_CANCEL',
  'SERVICE_PAGE_MIGRATE',
  'SERVICE_PAGE_EDGE_OPEN',
  'SERVICE_PAGE_REMOTEACCESS_EDIT',
  'SERVICE_PAGE_SOURCES_EDIT',
  'SERVICE_PAGE_SOURCES_OPEN',
  'SERVICE_PAGE_SOURCES_UPLOAD',
  'SERVICE_PAGE_CONTAINERS_SCALE_SERVICE',
  'SERVICE_PAGE_CONTAINERS_BALANCE_SERVICE',
  'SERVICE_PAGE_CONTAINERS_OPEN_LOGPROVIDER',
  'SERVICE_PAGE_CONTAINERS_EXECUTE_SERVICE',
  'SERVICE_PAGE_EDIT',
  'SERVICE_PAGE_PASSWORD',
  'SERVICE_PAGE_CLONE',
  'SERVICE_PAGE_DESTROY',
  'SERVICE_PAGE_DESTROY_FORCE',
  'SERVICE_PAGE_DESTROY_DEPLOY',
  'SERVICE_PAGE_DESTROY_TRY',
  'SERVICE_PAGE_DESTROY_SUCCESS',
  'SERVICE_PAGE_DESTROY_FAIL',
  'SERVICE_PAGE_TASKS_ADD',
  'SERVICE_PAGE_TASKS_SAVE',
  'SERVICE_PAGE_TASKS_TOGGLE',
  'SERVICE_PAGE_TASKS_LOG',
  'SERVICE_PAGE_BACKUP',
  'SERVICE_PAGE_RESTORE',
  'SERVICE_PAGE_WEBHOOKS_COPY',
  'SERVICE_PAGE_WEBHOOKS_REGENERATE',
  'SERVICE_PAGE_WEBHOOKS_SUBSCRIBE',
  'HOST_PAGE_WARNING_RECREATE',
  'HOST_PAGE_WARNING_RESETUP',
  'HOST_PAGE_WARNING_RESTART',
  'HOST_PAGE_RECREATE',
  'HOST_PAGE_RESETUP',
  'HOST_PAGE_START',
  'HOST_PAGE_RESTART',
  'HOST_PAGE_STOP',
  'HOST_PAGE_CANCEL',
  'HOST_PAGE_UPDATE_UTILS',
  'HOST_PAGE_RESIZE',
  'HOST_PAGE_START_CONTAINERS',
  'HOST_PAGE_STOP_CONTAINERS',
  'HOST_PAGE_EDIT',
  'HOST_PAGE_TERMINAL',
  'HOST_PAGE_DESTROY',
  'HOST_PAGE_DESTROY_FORCE',
  'HOST_PAGE_DESTROY_TRY',
  'HOST_PAGE_DESTROY_SUCCESS',
  'HOST_PAGE_DESTROY_FAIL',
  // ---------------------------------------------------------------------------
  'CREATE_ACCOUNT_TRY',
  'CREATE_ACCOUNT_SUCCESS',
  'CREATE_ACCOUNT_FAIL',
  'CREATE_MEMBER_TRY',
  'CREATE_MEMBER_SUCCESS',
  'CREATE_MEMBER_FAIL',
  'CREATE_ROLE_TRY',
  'CREATE_ROLE_SUCCESS',
  'CREATE_ROLE_FAIL',
  'UPDATE_ACCOUNT_TRY',
  'UPDATE_ACCOUNT_SUCCESS',
  'UPDATE_ACCOUNT_FAIL',
  'UPDATE_ACCOUNT_DELETE_TRY',
  'UPDATE_ACCOUNT_DELETE_SUCCESS',
  'UPDATE_ACCOUNT_DELETE_FAIL',
  'UPDATE_ACCOUNT_LEAVE',
  'UPDATE_ACCOUNT_LEAVE_TRY',
  'UPDATE_ACCOUNT_LEAVE_SUCCESS',
  'UPDATE_ACCOUNT_LEAVE_FAIL',
  'UPDATE_ACCOUNT_SET_DEFAULT_TRY',
  'UPDATE_ACCOUNT_SET_DEFAULT_SUCCESS',
  'UPDATE_ACCOUNT_SET_DEFAULT_FAIL',
  'UPDATE_MEMBER_TRY',
  'UPDATE_MEMBER_SUCCESS',
  'UPDATE_MEMBER_FAIL',
  'UPDATE_MEMBER_DELETE_TRY',
  'UPDATE_MEMBER_DELETE_SUCCESS',
  'UPDATE_MEMBER_DELETE_FAIL',
  'UPDATE_ROLE_TRY',
  'UPDATE_ROLE_SUCCESS',
  'UPDATE_ROLE_FAIL',
  'UPDATE_ROLE_DELETE_TRY',
  'UPDATE_ROLE_DELETE_SUCCESS',
  'UPDATE_ROLE_DELETE_FAIL',
  'CREATE_PROVIDER_OAUTH',
  'CREATE_PROVIDER_TRY',
  'CREATE_PROVIDER_SUCCESS',
  'CREATE_PROVIDER_FAIL',
  'CREATE_PROVIDER_SELECT_AWS',
  'CREATE_PROVIDER_SELECT_DO',
  'CREATE_PROVIDER_SELECT_CUSTOM',
  'CREATE_PROVIDER_SELECT_GCP',
  'CREATE_PROVIDER_SELECT_UPCLOUD',
  'CREATE_PROVIDER_SELECT_VULTR',
  'CREATE_PROVIDER_SELECT_BACKBLAZE',
  'CREATE_PROVIDER_SELECT_DROPBOX',
  'CREATE_PROVIDER_SELECT_FTP',
  'CREATE_PROVIDER_SELECT_HUBIC',
  'CREATE_PROVIDER_SELECT_ONEDRIVE',
  'CREATE_PROVIDER_SELECT_S3',
  'CREATE_PROVIDER_SELECT_SFTP',
  'CREATE_PROVIDER_SELECT_SPACES',
  'CREATE_PROVIDER_SELECT_GELF',
  'CREATE_PROJECT_TRY',
  'CREATE_PROJECT_SUCCESS',
  'CREATE_PROJECT_FAIL',
  'UPDATE_PROJECT_TRY',
  'UPDATE_PROJECT_SUCCESS',
  'UPDATE_PROJECT_FAIL',
  'CREATE_DEMOHOST_SUCCESS',
  'CREATE_DEMOHOST_FAIL',
  'CONNECT_HOST_SUCCESS',
  'CONNECT_HOST_FAIL',
  'CONNECT_HOST_SUBSCRIBE',
  'CREATE_HOST_SUCCESS',
  'CREATE_HOST_FAIL',
  'CREATE_HOST_SUBSCRIBE',
  'UPDATE_HOST_INSTANCE_TRY',
  'UPDATE_HOST_INSTANCE_SUCCESS',
  'UPDATE_HOST_INSTANCE_FAIL',
  'UPDATE_HOST_DISK_TRY',
  'UPDATE_HOST_DISK_SUCCESS',
  'UPDATE_HOST_DISK_FAIL',
  'UPDATE_HOST_KEYS_TRY',
  'UPDATE_HOST_KEYS_SUCCESS',
  'UPDATE_HOST_KEYS_FAIL',
  'CREATE_SERVICE_TRY',
  'CREATE_SERVICE_SUCCESS',
  'CREATE_SERVICE_FAIL',
  'CREATE_SERVICE_SELECT_CRATE',
  'CREATE_SERVICE_SELECT_DOCKER',
  'CREATE_SERVICE_SELECT_ELASTICSEARCH',
  'CREATE_SERVICE_SELECT_GO',
  'CREATE_SERVICE_SELECT_HAPROXY',
  'CREATE_SERVICE_SELECT_MARIADB',
  'CREATE_SERVICE_SELECT_MEMCACHED',
  'CREATE_SERVICE_SELECT_MONGODB',
  'CREATE_SERVICE_SELECT_MYSQL',
  'CREATE_SERVICE_SELECT_NGINX',
  'CREATE_SERVICE_SELECT_NGINXSTATIC',
  'CREATE_SERVICE_SELECT_NODEJS',
  'CREATE_SERVICE_SELECT_PERCONA',
  'CREATE_SERVICE_SELECT_PHPAPACHE',
  'CREATE_SERVICE_SELECT_PHPNGINX',
  'CREATE_SERVICE_SELECT_POSTGRES',
  'CREATE_SERVICE_SELECT_PYTHON',
  'CREATE_SERVICE_SELECT_REDIS',
  'CREATE_SERVICE_SELECT_RUBY',
  'CREATE_SERVICE_SELECT_VARNISH',
  'UPDATE_SERVICE_TRY',
  'UPDATE_SERVICE_SUCCESS',
  'UPDATE_SERVICE_FAIL',
  'UPDATE_SERVICE_PASSWORD_TRY',
  'UPDATE_SERVICE_PASSWORD_SUCCESS',
  'UPDATE_SERVICE_PASSWORD_FAIL',
  'UPDATE_SERVICE_LOGPROVIDER_TRY',
  'UPDATE_SERVICE_LOGPROVIDER_SUCCESS',
  'UPDATE_SERVICE_LOGPROVIDER_FAIL',
  'UPDATE_SERVICE_REMOTEACCESS_TRY',
  'UPDATE_SERVICE_REMOTEACCESS_SUCCESS',
  'UPDATE_SERVICE_REMOTEACCESS_FAIL',
  'UPDATE_SERVICE_SERVICES_TRY',
  'UPDATE_SERVICE_SERVICES_SUCCESS',
  'UPDATE_SERVICE_SERVICES_FAIL',
  'MIGRATE_SERVICE_TRY',
  'MIGRATE_SERVICE_SUCCESS',
  'MIGRATE_SERVICE_FAIL',
  'SCALE_SERVICE_TRY',
  'SCALE_SERVICE_SUCCESS',
  'SCALE_SERVICE_FAIL',
  'RESTORE_SERVICE_TRY',
  'RESTORE_SERVICE_SUCCESS',
  'RESTORE_SERVICE_FAIL',
  'BACKUP_SERVICE_TRY',
  'BACKUP_SERVICE_SUCCESS',
  'BACKUP_SERVICE_FAIL',
  'BACKUP_SERVICE_NEW_PROVIDER',
  'CREATE_KEY_TRY',
  'CREATE_KEY_SUCCESS',
  'CREATE_KEY_FAIL',
  'MOVE_CONTAINER_TRY',
  'MOVE_CONTAINER_SUCCESS',
  'MOVE_CONTAINER_FAIL',
  'IMPORT_STACK_TRY',
  'IMPORT_STACK_SUCCESS',
  'IMPORT_STACK_FAIL',
  // ---------------------------------------------------------------------------
  'HOST_FORM_NEW_PROVIDER',
  'HOST_FORM_NEW_KEY',
  'SERVICE_FORM_NEW_PROJECT',
  'SERVICE_FORM_NEW_PROVIDER',
  'SERVICE_FORM_PASSWORD_GENERATE',
  'SERVICE_FORM_PASSWORD_COPY',
  'SERVICE_FORM_SOURCES_UPLOAD',
  'SERVICE_FORM_CONFIGS_COPY_PATH',
  'STACK_FORM_NEW_PROJECT',
  'STACK_FORM_NEW_HOST',
  'STACK_FORM_TEMPLATE',
  'STACK_FORM_UPLOAD_TRY',
  'STACK_FORM_UPLOAD_SUCCESS',
  'STACK_FORM_UPLOAD_FAIL',
  'STACK_FORM_URL',
  // ---------------------------------------------------------------------------
  'EXECUTION_MANAGER_UPLOAD',
  'EXECUTION_MANAGER_EXECUTE_ON_SERVICE',
  'EXECUTION_MANAGER_EXECUTE_ON_CONTAINER',
  'EXECUTION_MANAGER_EXECUTE_SUCCESS',
  'EXECUTION_MANAGER_EXECUTE_FAIL',
  'LOGS_MANAGER_SELECT_HOST',
  'LOGS_MANAGER_SELECT_SERVICE',
  'LOGS_MANAGER_SELECT_CONTAINER',
  'LOGS_MANAGER_SELECT_TASK',
  'LOGS_SEARCH_DATE',
  'LOGS_SEARCH_PAGE',
  'LOGS_SEARCH_TEXT',
  'METRICS_HOUR',
  'METRICS_DAY',
  'METRICS_WEEK',
  'METRICS_MONTH',
  'METRICS_SMALL',
  'METRICS_WIDE',
  'NOTIFICATIONS_CLOSE',
  'NOTIFICATIONS_CLOSE_ICON',
  'NOTIFICATIONS_CLOSE_ALL',
  'NOTIFICATIONS_OPEN_ENTITY',
]

const icons = [
  'ad', 'adjust', 'allergies', 'ambulance', 'anchor', 'angry', 'ankh', 'archive', 'archway', 'asterisk', 'at', 'atlas', 'atom', 'award', 'baby', 'backspace', 'backward', 'bacon', 'bahai', 'ban', 'barcode', 'bars', 'bath', 'bed', 'beer', 'bell', 'bible', 'bicycle', 'biking', 'binoculars', 'biohazard', 'blender', 'blind', 'blog', 'bold', 'bolt', 'bomb', 'bone', 'bong', 'book', 'bookmark', 'box', 'boxes', 'braille', 'brain', 'briefcase', 'broom', 'brush', 'bug', 'building', 'bullhorn', 'bullseye', 'burn', 'bus', 'calculator', 'calendar', 'camera', 'campground', 'cannabis', 'capsules', 'car', 'caravan', 'carrot', 'cat', 'certificate', 'chair', 'chalkboard', 'check', 'cheese', 'chess', 'child', 'church', 'circle', 'city', 'clipboard', 'clock', 'clone', 'cloud', 'cocktail', 'code', 'coffee', 'cog', 'cogs', 'coins', 'columns', 'comment', 'comments', 'compass', 'compress', 'cookie', 'copy', 'copyright', 'couch', 'crop', 'cross', 'crosshairs', 'crow', 'crown', 'crutch', 'cube', 'cubes', 'cut', 'database', 'deaf', 'democrat', 'desktop', 'dharmachakra', 'diagnoses', 'dice', 'directions', 'disease', 'divide', 'dizzy', 'dna', 'dog', 'dolly', 'donate', 'dove', 'download', 'dragon', 'drum', 'dumbbell', 'dumpster', 'dungeon', 'edit', 'egg', 'eject', 'envelope', 'equals', 'eraser', 'ethernet', 'exclamation', 'expand', 'eye', 'fan', 'faucet', 'fax', 'feather', 'female', 'file', 'fill', 'film', 'filter', 'fingerprint', 'fire', 'fish', 'flag', 'flask', 'flushed', 'folder', 'font', 'forward', 'frog', 'frown', 'fruit-apple', 'futbol', 'gamepad', 'gavel', 'gem', 'ghost', 'gift', 'gifts', 'glasses', 'globe', 'gopuram', 'grimace', 'grin', 'guitar', 'hamburger', 'hammer', 'hamsa', 'hands', 'handshake', 'hanukiah', 'hashtag', 'hdd', 'heading', 'headphones', 'headset', 'heart', 'heartbeat', 'helicopter', 'highlighter', 'hiking', 'hippo', 'history', 'home', 'horse', 'hospital', 'hotdog', 'hotel', 'hourglass', 'hryvnia', 'icicles', 'icons', 'igloo', 'image', 'images', 'inbox', 'indent', 'industry', 'infinity', 'info', 'italic', 'jedi', 'joint', 'kaaba', 'key', 'keyboard', 'khanda', 'kiss', 'landmark', 'language', 'laptop', 'laugh', 'leaf', 'lemon', 'lightbulb', 'linkify', 'list', 'lock', 'lungs', 'magic', 'magnet', 'male', 'map', 'marker', 'mars', 'mask', 'medal', 'medkit', 'meh', 'memory', 'menorah', 'mercury', 'meteor', 'microchip', 'microphone', 'microscope', 'minus', 'mitten', 'mobile', 'monument', 'moon', 'mosque', 'motorcycle', 'mountain', 'mouse', 'music', 'neuter', 'newspaper', 'om', 'otter', 'outdent', 'pager', 'palette', 'pallet', 'paperclip', 'paragraph', 'parking', 'passport', 'pastafarianism', 'paste', 'pause', 'paw', 'peace', 'pen', 'percent', 'percentage', 'phone', 'pills', 'plane', 'play', 'plug', 'plus', 'podcast', 'poll', 'poo', 'poop', 'portrait', 'pray', 'prescription', 'print', 'procedures', 'qrcode', 'question', 'quidditch', 'quran', 'radiation', 'rainbow', 'random', 'receipt', 'recycle', 'redo', 'registered', 'reply', 'republican', 'restroom', 'retweet', 'ribbon', 'ring', 'road', 'robot', 'rocket', 'route', 'rss', 'ruler', 'running', 'satellite', 'save', 'school', 'screwdriver', 'scroll', 'search', 'seedling', 'server', 'shapes', 'share', 'ship', 'shower', 'sign', 'signal', 'signature', 'sitemap', 'skating', 'skiing', 'skull', 'slash', 'sleigh', 'smile', 'smog', 'smoking', 'sms', 'snowboarding', 'snowflake', 'snowman', 'snowplow', 'soap', 'socks', 'sort', 'spa', 'spider', 'spinner', 'splotch', 'square', 'stamp', 'star', 'stethoscope', 'stop', 'stopwatch', 'store', 'stream', 'strikethrough', 'stroopwafel', 'subscript', 'subway', 'suitcase', 'sun', 'superscript', 'surprise', 'swatchbook', 'swimmer', 'synagogue', 'sync', 'syringe', 'table', 'tablet', 'tablets', 'tag', 'tags', 'tape', 'tasks', 'taxi', 'teeth', 'tenge', 'terminal', 'th', 'thermometer', 'thumbtack', 'times', 'tint', 'tired', 'toilet', 'toolbox', 'tools', 'tooth', 'torah', 'tractor', 'trademark', 'trailer', 'train', 'tram', 'trash', 'tree', 'trophy', 'truck', 'tshirt', 'tty', 'tv', 'umbrella', 'underline', 'undo', 'university', 'unlink', 'unlock', 'upload', 'user', 'users', 'utensils', 'venus', 'vial', 'vials', 'video', 'vihara', 'virus', 'viruses', 'voicemail', 'walking', 'wallet', 'warehouse', 'water', 'weight', 'wheelchair', 'wifi', 'wind', 'wrench', '', 'add', 'alarm', 'ald', 'als', 'announcement', 'asl', 'attach', 'attention', 'balance', 'bar', 'bathtub', 'birthday', 'browser', 'call', 'cancel', 'cart', 'cc', 'chain', 'chat', 'checkmark', 'close', 'cny', 'cocktail', 'commenting', 'compose', 'computer', 'configure', 'content', 'conversation', 'currency', 'dashboard', 'deafness', 'delete', 'detective', 'diamond', 'discussions', 'disk', 'doctor', 'dollar', 'dont', 'dropdown', 'emergency', 'erase', 'eur', 'euro', 'exchange', 'external', 'eyedropper', 'factory', 'favorite', 'feed', 'find', 'food', 'fork', 'game', 'gay', 'gbp', 'grab', 'graduation', 'group', 'h', 'hamburger', 'handicap', 'header', 'help', 'hide', 'hotel', 'idea', 'ils', 'inr', 'jpy', 'krw', 'lab', 'law', 'legal', 'lesbian', 'lightning', 'like', 'linkify', 'lira', 'magnify', 'mail', 'man', 'marker', 'meanpath', 'military', 'money', 'move', 'mute', 'options', 'payment', 'pencil', 'photo', 'picture', 'pin', 'point', 'pound', 'power', 'privacy', 'protect', 'puzzle', 'radio', 'rain', 'record', 'refresh', 'remove', 'repeat', 'rmb', 'rouble', 'rub', 'ruble', 'rupee', 's15', 'send', 'setting', 'settings', 'shekel', 'sheqel', 'shield', 'shipping', 'shop', 'shuffle', 'shutdown', 'sidebar', 'signing', 'signup', 'sliders', 'soccer', 'sound', 'spoon', 'spy', 'student', 'talk', 'target', 'teletype', 'television', 'theme', 'thermometer', 'ticket', 'time', 'tm', 'translate', 'travel', 'treatment', 'try', 'unhide', 'unlinkify', 'unmute', 'usd', 'vcard', 'wait', 'warning', 'winner', 'wizard', 'woman', 'won', 'world', 'write', 'x', 'yen', 'zip', 'zoom'
]

const names = [
  'abby', 'angel', 'annie', 'baby', 'bailey', 'bandit', 'bear', 'bella', 'bob', 'boo', 'boots', 'bubba', 'buddy', 'buster', 'cali', 'callie', 'casper', 'charlie', 'chester', 'chloe', 'cleo', 'coco', 'cookie', 'cuddles', 'daisy', 'dusty', 'felix', 'fluffy', 'garfield', 'george', 'ginger', 'gizmo', 'gracie', 'harley', 'jack', 'jasmine', 'jasper', 'kiki', 'kitty', 'leo', 'lilly', 'lily', 'loki', 'lola', 'lucky', 'lucy', 'luna', 'maggie', 'max', 'mia', 'midnight', 'milo', 'mimi', 'missy', 'misty', 'mittens', 'molly', 'muffin', 'nala', 'oliver', 'oreo', 'oscar', 'patches', 'peanut', 'pepper', 'precious', 'princess', 'pumpkin', 'rascal', 'rocky', 'sadie', 'salem', 'sam', 'samantha', 'sammy', 'sasha', 'sassy', 'scooter', 'shadow', 'sheba', 'simba', 'simon', 'smokey', 'snickers', 'snowball', 'snuggles', 'socks', 'sophie', 'spooky', 'sugar', 'tiger', 'tigger', 'tinkerbell', 'toby', 'trouble', 'whiskers', 'willow', 'zoe', 'zoey', 'bella', 'lucy', 'daisy', 'molly', 'lola', 'sophie', 'sadie', 'maggie', 'chloe', 'bailey', 'roxy', 'zoey', 'lily', 'luna', 'coco', 'stella', 'gracie', 'abby', 'penny', 'zoe', 'ginger', 'ruby', 'rosie', 'lilly', 'ellie', 'mia', 'sasha', 'lulu', 'pepper', 'nala', 'lexi', 'lady', 'emma', 'riley', 'dixie', 'annie', 'maddie', 'piper', 'princess', 'izzy', 'maya', 'olive', 'cookie', 'roxie', 'angel', 'belle', 'layla', 'missy', 'cali', 'honey', 'millie', 'harley', 'marley', 'holly', 'kona', 'shelby', 'jasmine', 'ella', 'charlie', 'minnie', 'willow', 'phoebe', 'callie', 'scout', 'katie', 'dakota', 'sugar', 'sandy', 'josie', 'macy', 'trixie', 'winnie', 'peanut', 'mimi', 'hazel', 'mocha', 'cleo', 'hannah', 'athena', 'lacey', 'sassy', 'lucky', 'bonnie', 'allie', 'brandy', 'sydney', 'casey', 'gigi', 'baby', 'madison', 'heidi', 'sally', 'shadow', 'cocoa', 'pebbles', 'misty', 'nikki', 'lexie', 'grace', 'sierra', 'max', 'buddy', 'charlie', 'jack', 'cooper', 'rocky', 'toby', 'tucker', 'jake', 'bear', 'duke', 'teddy', 'oliver', 'riley', 'bailey', 'bentley', 'milo', 'buster', 'cody', 'dexter', 'winston', 'murphy', 'leo', 'lucky', 'oscar', 'louie', 'zeus', 'henry', 'sam', 'harley', 'baxter', 'gus', 'sammy', 'jackson', 'bruno', 'diesel', 'jax', 'gizmo', 'bandit', 'rusty', 'marley', 'jasper', 'brody', 'roscoe', 'hank', 'otis', 'bo', 'joey', 'beau', 'ollie', 'tank', 'shadow', 'peanut', 'hunter', 'scout', 'blue', 'rocco', 'simba', 'tyson', 'ziggy', 'boomer', 'romeo', 'apollo', 'ace', 'luke', 'rex', 'finn', 'chance', 'rudy', 'loki', 'moose', 'george', 'samson', 'coco', 'benny', 'thor', 'rufus', 'prince', 'chester', 'brutus', 'scooter', 'chico', 'spike', 'gunner', 'sparky', 'mickey', 'kobe', 'chase', 'oreo', 'frankie', 'mac', 'benji', 'bubba', 'champ', 'brady', 'elvis', 'copper', 'cash', 'archie', 'walter'
]

const stacks = [
  { "title": "Adminer", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/adminer-featured-150x150.png", "repo": "https://github.com/d2cio/adminer-stack" },
  { "title": "Adminer+NGINX", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/adminer-featured-150x150.png", "repo": "https://github.com/d2cio/adminer-nginx-stack" },
  { "title": "Alfio", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/01/c7fc010f-alfio-black-150x150.png", "repo": "https://github.com/d2cio/alfio-stack" },
  { "title": "Botpress", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/10/6ce2de22-botpress-150x150.png", "repo": "https://github.com/d2cio/botpress-stack" },
  { "title": "Cachethq", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/Cachet-featured-150x150.png", "repo": "https://github.com/d2cio/cachethq-stack" },
  { "title": "Code-server", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/08/e6ca51fc-code-server-150x150.png", "repo": "https://github.com/d2cio/code-server-stack" },
  { "title": "Elastic stack", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/09/a90f3316-elasticsearch-150x150.png", "repo": "https://github.com/d2cio/elastic-stack" },
  { "title": "Faveo", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/09/faveo-featured-150x150.png", "repo": "https://github.com/d2cio/faveo-stack" },
  { "title": "Fider", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/12/fider_featured-150x150.png", "repo": "https://github.com/d2cio/fider-stack" },
  { "title": "Freescout", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/10/64c5a59f-freescout-150x150.png", "repo": "https://github.com/d2cio/freescout-stack" },
  { "title": "Ghost", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/ghost-featured-150x150.png", "repo": "https://github.com/d2cio/ghost-stack" },
  { "title": "Gitea", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/11/f781be5e-gitea-150x150.png", "repo": "https://github.com/d2cio/gitea-stack" },
  { "title": "Helpy", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/09/helpy-featured-150x150.png", "repo": "https://github.com/d2cio/helpy-stack" },
  { "title": "HumHub", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/07/614fc548-humhub-150x150.png", "repo": "https://github.com/d2cio/humhub-stack" },
  { "title": "Logstash-InfluxDB-Grafana stack", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/09/5743e3f2-lig-stack-150x150.png", "repo": "https://github.com/d2cio/logstash-influxdb-grafana-stack" },
  { "title": "MEAN", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mean-featured-150x150.png", "repo": "https://github.com/d2cio/mean-stack" },
  { "title": "MEAN Light", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mean-featured-150x150.png", "repo": "https://github.com/d2cio/mean-light-stack" },
  { "title": "Magento2", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/01/magento-featured-150x150.png", "repo": "https://github.com/d2cio/magento2-stack" },
  { "title": "MailDev", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/01/6656c603-maildev-150x150.png", "repo": "https://github.com/d2cio/maildev-stack/" },
  { "title": "MariaDB MasterSlave + phpMyAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mariadb-logo-featured-150x150.png", "repo": "https://github.com/d2cio/mariadb-masterslave-stack" },
  { "title": "MariaDB + phpMyAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mariadb-logo-featured-150x150.png", "repo": "https://github.com/d2cio/mariadb-stack" },
  { "title": "Matomo", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/11/matomo-150x150.png", "repo": "https://github.com/d2cio/matomo-stack" },
  { "title": "Mattermost", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/12/mattermost-featured-150x150.png", "repo": "https://github.com/d2cio/mattermost-stack" },
  { "title": "Mautic", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/12/mautic-featured-150x150.png", "repo": "https://github.com/d2cio/mautic-stack" },
  { "title": "Metabase with PostgreSQL", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/06/1a8d3fff-metabase-150x150.png", "repo": "https://github.com/d2cio/metabase-postgres-stack" },
  { "title": "MinIO", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/11/b0789af0-minio-150x150.png", "repo": "https://github.com/d2cio/minio-stack" },
  { "title": "MongoDB ReplicaSet + mongo-express", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mongo-express-150x150.png", "repo": "https://github.com/d2cio/mongodb-replicaset-stack" },
  { "title": "MongoDB + mongo-express", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mongo-express-150x150.png", "repo": "https://github.com/d2cio/mongodb-stack" },
  { "title": "MySQL MasterSlave + phpMyAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mysql-featured-logo.png", "repo": "https://github.com/d2cio/mysql-masterslave-stack" },
  { "title": "MySQL+phpMyAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/mysql-featured-logo.png", "repo": "https://github.com/d2cio/mysql-stack" },
  { "title": "Nextcloud", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/10/nextcloud-featured-150x150.png", "repo": "https://github.com/d2cio/nextcloud-stack" },
  { "title": "Odoo", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/odoo-featured-150x150.png", "repo": "https://github.com/d2cio/odoo-stack" },
  { "title": "Opencart", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/01/opencart-featured-150x150.png", "repo": "https://github.com/d2cio/opencart-stack" },
  { "title": "Passbolt", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/08/5f64f399-passbolt-150x150.png", "repo": "https://github.com/d2cio/passbolt-stack" },
  { "title": "Patroni HA PostgreSQL", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/08/a092d314-patroni-150x150.png", "repo": "https://github.com/d2cio/patroni-stack" },
  { "title": "Percona MasterSlave + phpMyAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/percona-featured-150x150.png", "repo": "https://github.com/d2cio/percona-masterslave-stack" },
  { "title": "Percona + phpMyAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/percona-featured-150x150.png", "repo": "https://github.com/d2cio/percona-stack" },
  { "title": "PgAdmin", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/pgadmin-featured-150x150.png", "repo": "https://github.com/d2cio/pgAdmin-stack" },
  { "title": "Pimcore", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/10/e58f0484-pimcore-150x150.png", "repo": "https://github.com/d2cio/pimcore-stack" },
  { "title": "Prestashop Apache", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/07/23599804-prestashop-150x150.png", "repo": "https://github.com/d2cio/prestashop-apache-stack" },
  { "title": "PyroCMS", "active": false, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/03/pyrocms-150x150.png", "repo": "https://github.com/d2cio/pyrocms-stack" },
  { "title": "Redmine", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/redmine-featured-150x150.png", "repo": "https://github.com/d2cio/redmine-stack" },
  { "title": "Restyaboard", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/10/55b12233-restya-150x150.png", "repo": "https://github.com/d2cio/restyaboard-stack" },
  { "title": "Rocket.Chat", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/rocketchat-featured-150x150.png", "repo": "https://github.com/d2cio/rocketchat-stack" },
  { "title": "Rocket.Chat v.1 with ReplicaSet", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/rocketchat-featured-150x150.png", "repo": "https://github.com/d2cio/rocketchat-replicaset-stack" },
  { "title": "Sentry", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/2017-10-20_02h59_09-150x150.png", "repo": "https://github.com/d2cio/sentry-stack/sentry-stack" },
  { "title": "SQLPad with MSSQL", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/10/02714187-sqlpad-150x150.png", "repo": "https://github.com/d2cio/sqlpad-stack" },
  { "title": "Strapi with MongoDB", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/12/strapi_featured-150x150.png", "repo": "https://github.com/d2cio/strapi-mongo-stack" },
  { "title": "Strapi with PostgreSQL", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/12/strapi_featured-150x150.png", "repo": "https://github.com/d2cio/strapi-postgres-stack" },
  { "title": "SuiteCRM", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/07/703f5a66-suitecrm-150x150.png", "repo": "https://github.com/d2cio/suitecrm-stack" },
  { "title": "Taiga", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/12/19210c12-taiga-150x150.png", "repo": "https://github.com/d2cio/taiga-stack" },
  { "title": "Umami", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/10/0783f9c5-umami-150x150.png", "repo": "https://github.com/d2cio/umami-stack" },
  { "title": "Verdaccio (NPM registry)", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/07/087aa592-verdaccio-150x150.png", "repo": "https://github.com/d2cio/verdaccio-stack" },
  { "title": "Wekan", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2018/12/wekan_featured-150x150.png", "repo": "https://github.com/d2cio/wekan-stack" },
  { "title": "Wireguard", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2020/09/e0a402ce-wireguard-150x150.png", "repo": "https://github.com/d2cio/wireguard-stack" },
  { "title": "WooCommerce with NGINX cache", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/07/1e4320a5-woocommerce-150x150.png", "repo": "https://github.com/d2cio/wordpress-woocommerce-nginx-cache-stack" },
  { "title": "WordPress Light", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/2017-10-11_16h35_13-150x150.png", "repo": "https://github.com/d2cio/wordpress-scalable-light-stack" },
  { "title": "WordPress Light with NGINX cache", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/04/67b70748-wp_nginx_cache-150x150.png", "repo": "https://github.com/d2cio/wordpress-scalable-nginx-cache-light-stack" },
  { "title": "WordPress with Apache", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/2017-10-11_16h35_13-150x150.png", "repo": "https://github.com/d2cio/wordpress-scalable-apache-stack" },
  { "title": "WordPress with NGINX cache", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2019/04/67b70748-wp_nginx_cache-150x150.png", "repo": "https://github.com/d2cio/wordpress-scalable-nginx-cache-stack" },
  { "title": "WordPress with PHP-FPM", "active": true, "img": "https://storage.googleapis.com/stateless-d2c-io/2017/10/2017-10-11_16h35_13-150x150.png", "repo": "https://github.com/d2cio/wordpress-scalable-stack/" },
]

const d2c = {api, config, countries, goals, icons, logger, logos, names, objects, router, stacks, store, utils}

Object.defineProperty(d2c, 'version', { get() { return store.state.version } })

d2c.debug = () => {
  config.debug = true
}

export default d2c
